import crypto from "crypto";
import { GMMConfig } from "../types";

export class WebhooksResource {
  constructor(private config: GMMConfig) {}

  private verifySignature(params: {
    rawBody: string;
    signature: string;
    timestamp: string;
  }) {
    const { rawBody, signature, timestamp } = params;

    const FIVE_MINUTES = 5 * 60 * 1000;
    const now = Date.now();

    const timestampMs = new Date(timestamp).getTime();

    if (Number.isNaN(timestampMs)) {
      throw new Error("Invalid timestamp");
    }

    if (Math.abs(now - timestampMs) > FIVE_MINUTES) {
      throw new Error("Timestamp expired");
    }

    const expectedSignature = crypto
      .createHmac("sha256", this.config.webhookSecret)
      .update(`${timestamp}.${rawBody}`)
      .digest("hex");

    return crypto.timingSafeEqual(
      Buffer.from(signature, "utf8"),
      Buffer.from(expectedSignature, "utf8"),
    );
  }

  constructEvent(params: {
    rawBody: string;
    headers: {
      "gmm-webhook-signature": string;
      "gmm-webhook-timestamp": string;
    };
  }) {
    const isValid = this.verifySignature({
      rawBody: params.rawBody,
      signature: params.headers["gmm-webhook-signature"],
      timestamp: params.headers["gmm-webhook-timestamp"],
    });

    if (!isValid) {
      throw new Error("Invalid webhook signature");
    }

    return JSON.parse(params.rawBody);
  }
}
